const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['utils/KeyboardNavigatable'];